(() => {
  class DlPageBfProgressM extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('.dl-page-bf-progress-m__card')].map((card) => {
        const svg = card.querySelector('[data-progress-background]');
        return {
          card,
          svg,
          content: card.querySelector('.dl-page-bf-progress-m__content'),
          header: card.querySelector('.dl-page-bf-progress-m__header'),
          paths: [...svg.querySelectorAll('path')].map((path) => [path, path.getAttribute('d')]),
          heights: [...svg.querySelectorAll('filter[height]')].map((node) => [node, Number(node.getAttribute('height'))]),
          gradients: [...svg.querySelectorAll('linearGradient')].map((node) => [node, node.getAttribute('y1'), node.getAttribute('y2')]),
        };
      });
      this.resizeObserver = new ResizeObserver(() => this.updateBackgrounds());
      this.cards.forEach(({ content, header }) => {
        this.resizeObserver.observe(content);
        this.resizeObserver.observe(header);
      });
      this.updateBackgrounds();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateBackgrounds() {
      const canvasTop = 50.2498;
      this.cards.forEach(({ card, svg, content, header, paths, heights, gradients }) => {
        const bounds = content.getBoundingClientRect();
        if (!bounds.width || !bounds.height) return;
        const scale = bounds.width / 710;
        const ticketHeight = bounds.height / scale;
        const heightDelta = ticketHeight - 346;
        const sourceSeam = card.classList.contains('is-active') ? 222.25 : 221.25;
        const seamDelta = canvasTop + header.getBoundingClientRect().height / scale - sourceSeam;
        svg.setAttribute('viewBox', `0 0 819.239 ${455.239 + heightDelta}`);
        // All exported ticket commands are absolute M/L/C/Z. Move only the bottom
        // corners and the notch segment; keep their radii and the original filters.
        paths.forEach(([path, original]) => {
          path.setAttribute('d', original.replace(/[MLC][^MLCZ]*/g, (segment) => {
            let coordinate = 0;
            return segment.replace(/[-+]?(?:\d*\.)?\d+(?:e[-+]?\d+)?/gi, (value) => {
              if (coordinate++ % 2 === 0) return value;
              const y = Number(value);
              return String(y > 300 ? y + heightDelta : y > 180 && y < 250 ? y + seamDelta : y);
            });
          }));
        });
        heights.forEach(([node, height]) => node.setAttribute('height', String(height + heightDelta)));
        gradients.forEach(([node, y1, y2]) => {
          if (y1 !== null) node.setAttribute('y1', String(canvasTop + (Number(y1) - canvasTop) * ticketHeight / 346));
          if (y2 !== null) node.setAttribute('y2', String(canvasTop + (Number(y2) - canvasTop) * ticketHeight / 346));
        });
      });
    }
  }

  if (!customElements.get('dl-page-bf-progress-m')) {
    customElements.define('dl-page-bf-progress-m', DlPageBfProgressM);
  }
})();
